import { render, staticRenderFns } from "./ProductsImport.vue?vue&type=template&id=3bb9627f&"
import script from "./ProductsImport.vue?vue&type=script&lang=js&"
export * from "./ProductsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports